import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 313 98",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_dddd_2022_20405)",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_2022_20405",
				style: { maskType: "alpha" },
				maskUnits: "userSpaceOnUse",
				x: 2,
				y: 3,
				width: 89,
				height: 77,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M42.4858 12.166C45.8386 11.1626 49.4465 10.6816 53.1733 10.8398C56.8965 10.9979 60.3919 11.7726 63.646 13.043C72.395 16.4691 79.1118 23.5826 81.9478 32.2158L81.9497 32.2227L81.9517 32.2305C82.9942 35.382 83.5302 38.755 83.4556 42.2637C83.3809 45.7725 82.7022 49.1189 81.5269 52.2217L81.5229 52.2334L81.5181 52.2441C80.5254 54.8927 79.1383 57.3977 77.4253 59.7012C73.6941 64.6567 68.4872 68.5106 62.4233 70.5918C59.1333 71.7167 55.5744 72.3392 51.8706 72.3359L15.4292 72.2998C16.5622 69.9962 17.5035 67.5851 18.229 65.084C19.3064 61.4186 19.89 57.6032 19.9731 53.6982L20.2456 40.877C20.3236 37.209 21.0524 33.728 22.3228 30.5049L22.3237 30.501C24.6736 24.5279 28.9133 19.4382 34.3354 15.9219C35.2168 15.3517 36.1139 14.8336 37.0474 14.3584L37.0552 14.3545L37.063 14.3496C38.7963 13.4617 40.6069 12.7246 42.4731 12.1699L42.4858 12.166Z",
					stroke: "url(#paint0_linear_2022_20405)",
					strokeWidth: 13.8107
				})
			}), /* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask0_2022_20405)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						x: -21.2161,
						y: -25.9453,
						width: 135.038,
						height: 135.038,
						rx: 17.0868,
						fill: "url(#paint1_linear_2022_20405)"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: -21.2161,
						y: -25.9453,
						width: 135.038,
						height: 135.038,
						rx: 17.0868,
						fill: "url(#paint2_radial_2022_20405)",
						fillOpacity: .9
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: -21.2161,
						y: -25.9453,
						width: 135.038,
						height: 135.038,
						rx: 17.0868,
						fill: "url(#paint3_radial_2022_20405)"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: -21.2161,
						y: -25.9453,
						width: 135.038,
						height: 135.038,
						rx: 17.0868,
						fill: "url(#paint4_radial_2022_20405)"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: -21.2161,
						y: -25.9453,
						width: 135.038,
						height: 135.038,
						rx: 17.0868,
						fill: "url(#paint5_radial_2022_20405)"
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: -21.2161,
						y: -25.9453,
						width: 135.038,
						height: 135.038,
						rx: 17.0868,
						fill: "url(#paint6_radial_2022_20405)"
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter1_f_2022_20405)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M40.8136 6.89862C44.6726 5.72431 48.8152 5.16489 53.0838 5.34911C57.3525 5.53338 61.3712 6.43874 65.1007 7.91914C75.1724 11.9274 82.9565 20.2662 86.2603 30.4919C87.476 34.2283 88.1005 38.2293 88.0136 42.3799L87.9882 43.1547C87.8248 47.0244 87.0496 50.7285 85.7643 54.1781C84.5926 57.3565 82.967 60.3241 80.9899 63.021C76.6832 68.8363 70.6792 73.3555 63.6801 75.7962L62.9668 76.0345C59.3868 77.1974 55.5474 77.8363 51.5672 77.8328L4.5875 77.7848C4.89566 77.4612 5.19886 77.1251 5.49413 76.7808C9.1594 72.6331 11.9095 67.7309 13.444 62.3527C14.301 59.3957 14.7708 56.298 14.8376 53.1021L15.0954 40.7615C15.1804 36.7015 15.9313 32.8204 17.2458 29.2016L17.5155 28.4823C20.2584 21.3937 25.1819 15.4115 31.4207 11.2999C32.4388 10.6303 33.4835 10.0164 34.5736 9.45216C36.5494 8.42316 38.6367 7.55642 40.8136 6.89862ZM4.5875 77.7848C4.58579 77.7866 4.58472 77.789 4.58301 77.7908V77.7848H4.5875ZM52.6477 15.4434C49.543 15.3094 46.542 15.7164 43.7553 16.5643L43.7358 16.5688C42.2004 17.0328 40.6955 17.6555 39.2401 18.4135L39.2281 18.4195L39.2176 18.4255C38.4483 18.8237 37.7067 19.2586 36.9728 19.7412L36.9713 19.7397C32.4446 22.7254 28.9023 27.0531 26.9385 32.1283L26.9355 32.1343C25.8735 34.8739 25.2628 37.8374 25.1971 40.9728L24.9379 53.3149C24.8531 57.3663 24.2577 61.339 23.1486 65.1655L23.1456 65.164C22.9007 66.0195 22.6341 66.8652 22.3424 67.6995L51.5762 67.728C54.6575 67.7308 57.6174 67.2057 60.3548 66.2549C65.3829 64.5011 69.7291 61.2422 72.8587 57.0223C74.3003 55.0513 75.4608 52.9218 76.2859 50.6834L76.2979 50.6505C77.2807 48.0127 77.8491 45.1639 77.9119 42.1686C77.9745 39.173 77.5255 36.2993 76.6531 33.6179L76.6471 33.5984C74.2709 26.2439 68.647 20.2068 61.3723 17.3091C58.6553 16.2307 55.7475 15.5772 52.6477 15.4434Z",
							fill: "url(#paint7_linear_2022_20405)"
						})
					})
				]
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.799 25.1547H114.443L113.088 28.9053H110.765L116.863 12.1366H119.403L125.477 28.9053H123.154L121.799 25.1547ZM121.17 23.3641L118.121 14.8467L115.072 23.3641H121.17ZM133.119 15.4274C134.264 15.4274 135.264 15.6774 136.119 16.1775C136.99 16.6776 137.636 17.3067 138.055 18.0649V15.6452H140.281V29.1956C140.281 30.4055 140.023 31.4782 139.507 32.4139C138.991 33.3656 138.249 34.1077 137.281 34.64C136.329 35.1724 135.216 35.4385 133.942 35.4385C132.199 35.4385 130.748 35.0272 129.586 34.2045C128.425 33.3818 127.739 32.2606 127.529 30.8411H129.707C129.949 31.6476 130.449 32.2929 131.207 32.7768C131.966 33.2769 132.877 33.5269 133.942 33.5269C135.151 33.5269 136.136 33.1479 136.894 32.3897C137.668 31.6315 138.055 30.5668 138.055 29.1956V26.413C137.62 27.1873 136.974 27.8325 136.119 28.3487C135.264 28.8649 134.264 29.123 133.119 29.123C131.941 29.123 130.869 28.8327 129.901 28.2519C128.949 27.6712 128.199 26.8566 127.65 25.808C127.102 24.7595 126.828 23.5657 126.828 22.2268C126.828 20.8718 127.102 19.6861 127.65 18.6698C128.199 17.6374 128.949 16.8389 129.901 16.2743C130.869 15.7097 131.941 15.4274 133.119 15.4274ZM138.055 22.251C138.055 21.2509 137.854 20.3798 137.45 19.6377C137.047 18.8957 136.498 18.3311 135.805 17.9439C135.127 17.5406 134.377 17.339 133.554 17.339C132.732 17.339 131.982 17.5326 131.304 17.9197C130.627 18.3069 130.086 18.8715 129.683 19.6135C129.28 20.3556 129.078 21.2267 129.078 22.2268C129.078 23.2431 129.28 24.1303 129.683 24.8885C130.086 25.6306 130.627 26.2032 131.304 26.6065C131.982 26.9937 132.732 27.1873 133.554 27.1873C134.377 27.1873 135.127 26.9937 135.805 26.6065C136.498 26.2032 137.047 25.6306 137.45 24.8885C137.854 24.1303 138.055 23.2512 138.055 22.251ZM155.617 21.7671C155.617 22.1865 155.593 22.6301 155.544 23.0979H144.946C145.027 24.4046 145.47 25.4289 146.277 26.171C147.1 26.8969 148.092 27.2599 149.253 27.2599C150.205 27.2599 150.995 27.0421 151.625 26.6065C152.27 26.1549 152.721 25.558 152.98 24.8159H155.351C154.996 26.0903 154.286 27.1308 153.222 27.9374C152.157 28.7278 150.834 29.123 149.253 29.123C147.995 29.123 146.866 28.8407 145.866 28.2761C144.882 27.7115 144.107 26.913 143.543 25.8806C142.978 24.8321 142.696 23.6222 142.696 22.251C142.696 20.8799 142.97 19.6781 143.518 18.6456C144.067 17.6132 144.833 16.8228 145.817 16.2743C146.817 15.7097 147.963 15.4274 149.253 15.4274C150.511 15.4274 151.625 15.7016 152.592 16.2501C153.56 16.7986 154.302 17.5568 154.819 18.5247C155.351 19.4764 155.617 20.5572 155.617 21.7671ZM153.343 21.3073C153.343 20.4685 153.157 19.7506 152.786 19.1538C152.415 18.5408 151.907 18.081 151.262 17.7745C150.632 17.4519 149.931 17.2906 149.156 17.2906C148.043 17.2906 147.092 17.6455 146.301 18.3553C145.527 19.0651 145.083 20.0491 144.97 21.3073H153.343ZM164.5 15.4032C166.113 15.4032 167.42 15.8952 168.42 16.8792C169.42 17.8471 169.92 19.2506 169.92 21.0896V28.9053H167.743V21.4041C167.743 20.0813 167.412 19.0731 166.751 18.3795C166.089 17.6697 165.186 17.3148 164.041 17.3148C162.879 17.3148 161.952 17.6777 161.258 18.4037C160.58 19.1296 160.242 20.1862 160.242 21.5735V28.9053H158.04V15.6452H160.242V17.5326C160.677 16.855 161.266 16.3308 162.008 15.9597C162.766 15.5887 163.597 15.4032 164.5 15.4032ZM175.719 17.46V25.2757C175.719 25.9209 175.856 26.3807 176.131 26.6549C176.405 26.913 176.881 27.0421 177.558 27.0421H179.18V28.9053H177.195C175.969 28.9053 175.05 28.623 174.437 28.0584C173.824 27.4938 173.517 26.5662 173.517 25.2757V17.46H171.799V15.6452H173.517V12.306H175.719V15.6452H179.18V17.46H175.719Z",
			fill: "#3D435E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.205 55.0475C111.205 52.617 111.748 50.446 112.833 48.5346C113.943 46.5996 115.441 45.1011 117.329 44.0393C119.24 42.9538 121.376 42.411 123.736 42.411C126.496 42.411 128.915 43.1189 130.992 44.5348C133.068 45.9507 134.52 47.9093 135.346 50.4106H129.647C129.08 49.2307 128.278 48.3458 127.24 47.7559C126.225 47.1659 125.045 46.871 123.7 46.871C122.261 46.871 120.975 47.2131 119.842 47.8975C118.733 48.5582 117.86 49.5021 117.223 50.7292C116.609 51.9562 116.302 53.3957 116.302 55.0475C116.302 56.6758 116.609 58.1152 117.223 59.3659C117.86 60.593 118.733 61.5487 119.842 62.233C120.975 62.8937 122.261 63.2241 123.7 63.2241C125.045 63.2241 126.225 62.9291 127.24 62.3392C128.278 61.7257 129.08 60.8289 129.647 59.6491H135.346C134.52 62.174 133.068 64.1444 130.992 65.5603C128.939 66.9525 126.52 67.6487 123.736 67.6487C121.376 67.6487 119.24 67.1177 117.329 66.0558C115.441 64.9703 113.943 63.4719 112.833 61.5605C111.748 59.6491 111.205 57.4781 111.205 55.0475ZM147.578 67.7548C145.69 67.7548 143.991 67.3419 142.481 66.516C140.97 65.6665 139.779 64.4748 138.906 62.9409C138.056 61.4071 137.631 59.6373 137.631 57.6315C137.631 55.6257 138.068 53.8559 138.941 52.322C139.838 50.7882 141.053 49.6083 142.587 48.7824C144.121 47.9329 145.832 47.5081 147.719 47.5081C149.607 47.5081 151.318 47.9329 152.852 48.7824C154.386 49.6083 155.589 50.7882 156.462 52.322C157.359 53.8559 157.807 55.6257 157.807 57.6315C157.807 59.6373 157.347 61.4071 156.427 62.9409C155.53 64.4748 154.303 65.6665 152.746 66.516C151.212 67.3419 149.489 67.7548 147.578 67.7548ZM147.578 63.4365C148.474 63.4365 149.312 63.2241 150.091 62.7993C150.893 62.351 151.53 61.6903 152.002 60.8172C152.474 59.944 152.71 58.8821 152.71 57.6315C152.71 55.7673 152.215 54.3396 151.224 53.3485C150.256 52.3338 149.064 51.8265 147.649 51.8265C146.233 51.8265 145.041 52.3338 144.074 53.3485C143.13 54.3396 142.658 55.7673 142.658 57.6315C142.658 59.4957 143.118 60.9351 144.038 61.9498C144.982 62.9409 146.162 63.4365 147.578 63.4365ZM175.813 52.7114V56.8881H160.805V52.7114H175.813ZM185.618 50.6584C186.256 49.7617 187.129 49.0183 188.238 48.4284C189.37 47.8149 190.656 47.5081 192.096 47.5081C193.771 47.5081 195.282 47.9211 196.627 48.747C197.995 49.5729 199.069 50.7528 199.848 52.2866C200.65 53.7969 201.051 55.5549 201.051 57.5607C201.051 59.5665 200.65 61.3481 199.848 62.9055C199.069 64.4394 197.995 65.6311 196.627 66.4806C195.282 67.3301 193.771 67.7548 192.096 67.7548C190.656 67.7548 189.382 67.4599 188.273 66.8699C187.188 66.28 186.303 65.5367 185.618 64.64V76.7809H180.663V47.8267H185.618V50.6584ZM195.99 57.5607C195.99 56.3808 195.742 55.3661 195.246 54.5166C194.774 53.6435 194.137 52.9827 193.335 52.5344C192.556 52.086 191.707 51.8619 190.786 51.8619C189.89 51.8619 189.04 52.0978 188.238 52.5698C187.459 53.0181 186.822 53.6789 186.326 54.552C185.854 55.4251 185.618 56.4516 185.618 57.6315C185.618 58.8114 185.854 59.8378 186.326 60.711C186.822 61.5841 187.459 62.2566 188.238 62.7286C189.04 63.1769 189.89 63.4011 190.786 63.4011C191.707 63.4011 192.556 63.1651 193.335 62.6932C194.137 62.2212 194.774 61.5487 195.246 60.6756C195.742 59.8025 195.99 58.7642 195.99 57.5607ZM206.457 45.4905C205.584 45.4905 204.853 45.2191 204.263 44.6764C203.697 44.11 203.413 43.4139 203.413 42.588C203.413 41.7621 203.697 41.0778 204.263 40.535C204.853 39.9687 205.584 39.6855 206.457 39.6855C207.331 39.6855 208.05 39.9687 208.617 40.535C209.207 41.0778 209.502 41.7621 209.502 42.588C209.502 43.4139 209.207 44.11 208.617 44.6764C208.05 45.2191 207.331 45.4905 206.457 45.4905ZM208.9 47.8267V67.4363H203.944V47.8267H208.9ZM218.043 41.2429V67.4363H213.088V41.2429H218.043ZM230.939 67.7548C229.051 67.7548 227.352 67.3419 225.842 66.516C224.332 65.6665 223.14 64.4748 222.267 62.9409C221.417 61.4071 220.993 59.6373 220.993 57.6315C220.993 55.6257 221.429 53.8559 222.302 52.322C223.199 50.7882 224.414 49.6083 225.948 48.7824C227.482 47.9329 229.193 47.5081 231.081 47.5081C232.968 47.5081 234.679 47.9329 236.213 48.7824C237.747 49.6083 238.95 50.7882 239.824 52.322C240.72 53.8559 241.169 55.6257 241.169 57.6315C241.169 59.6373 240.708 61.4071 239.788 62.9409C238.891 64.4748 237.664 65.6665 236.107 66.516C234.573 67.3419 232.85 67.7548 230.939 67.7548ZM230.939 63.4365C231.836 63.4365 232.673 63.2241 233.452 62.7993C234.255 62.351 234.892 61.6903 235.364 60.8172C235.836 59.944 236.072 58.8821 236.072 57.6315C236.072 55.7673 235.576 54.3396 234.585 53.3485C233.617 52.3338 232.426 51.8265 231.01 51.8265C229.594 51.8265 228.402 52.3338 227.435 53.3485C226.491 54.3396 226.019 55.7673 226.019 57.6315C226.019 59.4957 226.479 60.9351 227.399 61.9498C228.343 62.9409 229.523 63.4365 230.939 63.4365ZM249.865 51.8973V61.3835C249.865 62.0442 250.019 62.528 250.326 62.8347C250.656 63.1179 251.199 63.2595 251.954 63.2595H254.255V67.4363H251.14C246.963 67.4363 244.874 65.4069 244.874 61.3481V51.8973H242.538V47.8267H244.874V42.9774H249.865V47.8267H254.255V51.8973H249.865Z",
			fill: "#3D435E"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_dddd_2022_20405",
				x: .703271,
				y: .83623,
				width: 111.148,
				height: 96.8202,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dx: 1.53452 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.53452 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.858824 0 0 0 0 0.67451 0 0 0 0 0.960784 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2022_20405"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 3.06904,
						dy: 3.06904
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.30178 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.858824 0 0 0 0 0.67451 0 0 0 0 0.960784 0 0 0 0.09 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_2022_20405",
						result: "effect2_dropShadow_2022_20405"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 7.67261,
						dy: 6.13809
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.06904 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.858824 0 0 0 0 0.67451 0 0 0 0 0.960784 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_2022_20405",
						result: "effect3_dropShadow_2022_20405"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 13.8107,
						dy: 10.7417
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.8363 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.858824 0 0 0 0 0.67451 0 0 0 0 0.960784 0 0 0 0.01 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_2022_20405",
						result: "effect4_dropShadow_2022_20405"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect4_dropShadow_2022_20405",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_f_2022_20405",
				x: -.440947,
				y: .290682,
				width: 93.4866,
				height: 82.566,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 2.51198,
						result: "effect1_foregroundBlur_2022_20405"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_2022_20405",
				x1: 7.1951,
				y1: 1.08014,
				x2: 104.832,
				y2: 52.2575,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .6
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: .8
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_2022_20405",
				x1: 46.3029,
				y1: 109.093,
				x2: 46.3029,
				y2: -25.9453,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#EED9FA" }), /* @__PURE__ */ _jsx("stop", {
					offset: .66,
					stopColor: "#DBACF5"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint2_radial_2022_20405",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(127.326 124.397) rotate(-128.593) scale(179.682 194.712)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#DBACF5" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DBACF5",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint3_radial_2022_20405",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(-23.9168 -32.247) rotate(53.1301) scale(99.0278 102.989)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#623875" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#623875",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint4_radial_2022_20405",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(75.3856 20.5537) rotate(146.478) scale(47.8432 49.7569)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF9903" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FF9903",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint5_radial_2022_20405",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(71.9936 72.2821) rotate(-145.26) scale(44.4099 46.1862)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#60ADE7" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#60ADE7",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint6_radial_2022_20405",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(26.1145 76.5388) rotate(-72.3872) scale(31.0176 32.2582)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00C06A" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#00C06A",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_2022_20405",
				x1: 9.27643,
				y1: 2.5952,
				x2: 102.369,
				y2: 50.5892,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .6
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: .8
				})]
			})
		] })
	]
});
export default SvgLogo;
